define('app-ImageGalleryPod/main',['./settings', 'bootstrap'],
    function (settings) {
        return {
            run: function () {
                var container = $(settings.container);

                if (container.length === 0) {
                    window.log('No Gallery Widgets found.  app-ImageGalleryPod will not be available.');
                    return;
                }

                //Initialize carousel
                $('.carousel').each(function () {
                    var currentCarousel = $(this);
                    var current = $(currentCarousel).find(".carousel-inner");
                    //Set prev slide and faded
                    $(".carousel-item:last-child", current).prependTo(current)
                    $(".carousel-item.active", current).prev().addClass('faded fadedPrev');
                    $(".carousel-item.active", current).next().addClass('faded fadedNext');
                    $('.carousel-item', current).css('display', 'block');
                    
                    ResizeCarousel(currentCarousel);

                });

                $(window).resize(function () {
                    $('.carousel').each(function () {
                        var currentCarousel = $(this);
                        var current = $(currentCarousel).find(".carousel-inner");

                        //show all slides breifly to recalc dimensions
                        $(current).css({ 'height': '0', 'visibility': 'hidden' });
                        $('.carousel-item', current).css('display', 'inline-block');

                        $('.carousel-item img, .carousel-item video', current).css('max-height', '');
                        $('.carousel-item', current).css('max-width', '');


                        ResizeCarousel(currentCarousel);
                    });
                    
                });

                function ResizeCarousel(currentCarousel) {
                    var current = $(currentCarousel).find(".carousel-inner");
                    //Get smallest slide height
                    var minHeight = 1000;
                    $('.carousel-item', current).each(function () {
                        var thisHeight = $(this).height();
                        if (thisHeight < minHeight) {
                            minHeight = thisHeight;
                        }
                    });
                    $('.carousel-item img, .carousel-item video', current).css('max-height', minHeight + 'px');

                    if ($(".vimeoVideo", current).length > 0) {
                        var vimeoHeight = $(".vimeoVideo", current).height();
                        var vimeoWidth = $(".vimeoVideo", current).width();
                        var ratio = vimeoWidth / vimeoHeight;
                        var newVimeoWidth = minHeight * ratio;
                        $(currentCarousel).carousel({
                            interval: 4000,
                            pause: true,
                            interval: false
                        });
                    }
                    else {
                        $(currentCarousel).carousel({
                            interval: 4000
                        });
                    }

                    $('.vimeoVideo', current).css('max-width', newVimeoWidth + 'px');

                    //Get img width and set to slide
                    $('.carousel-item', current).each(function () {

                        if ($(this).find('.vimeoVideo').length > 0) {
                            var imgWidth = $(this).find('.vimeoVideo').width();
                            $(this).attr('imgWidth', imgWidth);
                            $(this).css('max-width', imgWidth + 'px');
                        }
                        else {
                            var imgWidth = $(this).find('img').width();
                            $(this).attr('imgWidth', imgWidth);
                            $(this).css('max-width', imgWidth + 'px');
                        }
                        $(current).css('max-height', minHeight + 'px');

                        

                    });

                    //Use img width to set margins on faded slides
                    var prevWidth = $('.fadedPrev', current).attr('imgWidth');
                    $('.fadedPrev', current).css('margin-left', '-' + prevWidth + 'px');
                    var nextWidth = $('.fadedNext', current).attr('imgWidth');
                    $('.fadedNext', current).css('margin-right', nextWidth + 'px');
                    $(current).css({ 'height': 'auto', 'visibility': 'visible' });
                    $('.carousel-item', current).css('display', '');
                    $('.galleryContent', currentCarousel).show();

                    if ($(currentCarousel).find(".Individual").length > 0) {
                        var contentID = $('.carousel-item.active', current).attr('content-data');
                        $('#' + contentID).show();
                    }
                    if ($(current).children('.carousel-item').length === 1) $(current).siblings('.carousel-control-prev, .carousel-control-next').hide();

                }

                

                //On slide
                $('.carousel').on('slide.bs.carousel', function (e) {
                    var current = $(this).find(".carousel-inner");

                    var e = $(e.relatedTarget);
                    var itemsPerSlide = 3;
                    var totalItems = $('.carousel-item', current).length;
                    var itemsContainer = $(current);
                    var it = itemsPerSlide - (totalItems - e.index());
                    if (it > 0) {
                        for (var i = 0; i < it; i++) {
                            $('.carousel-item', current).eq(e.direction == "left" ? i : 0).
                                // append slides to the end/beginning
                                appendTo(itemsContainer);
                        }
                    }
                    $('.fadedPrev, .fadedNext', current).css({ 'margin-left': 0, 'margin-right': 0 });
                    $('.carousel-item.faded', current).removeClass('faded fadedPrev fadedNext');

                    
                });

                //After slide
                $('.carousel').on('slid.bs.carousel', function (e) {
                    var current = $(this).find(".carousel-inner");

                    if ($(".carousel-item.active", current).prev().length) {
                        $(".carousel-item.active", current).prev().addClass('faded fadedPrev');
                    }
                    else {

                        $(".carousel-item:last", current).addClass('faded fadedPrev');
                        $(".carousel-item:last-child", current).prependTo(current);
                    }

                    $(".carousel-item.active", current).next().addClass('faded fadedNext');

                    var prevWidth = $('.fadedPrev', current).attr('imgWidth');
                    $('.fadedPrev', current).css('margin-left', '-' + prevWidth + 'px');
                    var nextWidth = $('.fadedNext', current).attr('imgWidth');
                    $('.fadedNext', current).css('margin-right', nextWidth + 'px');

                    if ($(this).find(".Individual").length > 0) {
                        var contentID = $('.carousel-item.active', current).attr('content-data');
                        $('.Individual').hide();
                        $('#' + contentID).show();
                    }

                    //Cabin Grade Page Logic
                    if ($('.cabinGradesPage').is(':visible')) {
                        var carouselID = $(this).attr('id');
                        var currectMasterGrade = $('div[mastergrade="' +carouselID+'"]');
                        var roomgradeID = $(".carousel-item.active", current).attr('content-data');
                        $('.selectedGradeCodeRow', currectMasterGrade).removeClass('selectedGradeCodeRow');
                        $('#' + roomgradeID).addClass('selectedGradeCodeRow');
                    }
                });

                window.loadedModules('app-ImageGalleryPod');
            }
        }
    }
);
